<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general } from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'BeneficiaryRelationshipYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Have there been any significant changes or breakdowns in your relationship with anyone currently named in your Will?',
        subTitle: 'Family dynamics and friendships can evolve over time. If you have become estranged from a beneficiary, or if a relationship has changed to the point where you no longer wish them to inherit, your Will needs to reflect your current feelings. Addressing these changes now prevents disputes and ensures your assets go only to those you currently wish to benefit.',
        tip: null,
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'beneficiaryRelationshipYN',
        formPath: 'beneficiaryRelationshipYN',
        jsonSaveField: 'beneficiaryRelationshipYN',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
